import React from 'react';

import '../styles.scss';
import HelperCard from '../../../components/HelperCard';
import { determineSectionCards } from '../helpers/cards';

const Cards = ({ section, roles }) => {
  return (
    <div className="welcome-cards-container">
      {determineSectionCards(roles, section.cards).map((card, idx) => {
        return <HelperCard card={card} key={idx} type={section.type} buttonText={section.buttonText} />;
      })}
    </div>
  );
};

export default Cards;
